<div class="search-container">
  <div class="inputs">
    <div class="form-search">
      <button mat-stroked-button disableRipple [matMenuTriggerFor]="menu">
        <mat-icon>add</mat-icon>
        Selecionar Filtros
      </button>

      <!-- Date range picker for requestDate field if visible -->
      @for (field of visibleFields(); track field.key) {
        @if (field.type === "date-range") {
          <mat-form-field class="date-form">
            <mat-label>{{ field.label }}</mat-label>
            <mat-date-range-input [rangePicker]="picker">
              <input
                matStartDate
                placeholder="Data inicial"
                [formControl]="getFormControl(field.key + 'From')"
              />
              <input
                matEndDate
                placeholder="Data final"
                [formControl]="getFormControl(field.key + 'To')"
              />
            </mat-date-range-input>
            <mat-hint>DD/MM/AAAA – DD/MM/AAAA</mat-hint>
            <mat-datepicker-toggle
              matIconSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
          </mat-form-field>
        }
      }

      <mat-checkbox
        [formControl]="formControls['onlyMine']"
        class="only-mine-checkbox"
      >
        Meus relatórios
      </mat-checkbox>

      <button
        mat-flat-button
        [disabled]="(resultCount() ?? 0) <= 0"
        class="download"
        (click)="downloadReport()"
      >
        <mat-icon>file_download</mat-icon>
        Baixar Relatórios
      </button>
    </div>

    <mat-menu
      #menu="matMenu"
      class="filtros-container"
      [overlapTrigger]="false"
      (click)="$event.stopPropagation()"
    >
      <ng-template matMenuContent>
        @for (field of visibleFields(); track field.key) {
          <div class="filtro-bloco">
            <!-- Text inputs -->
            @if (field.type === "text") {
              <mat-form-field
                class="filter-field"
                (click)="$event.stopPropagation()"
              >
                <mat-label>{{ field.label }}</mat-label>
                <input
                  matInput
                  [formControl]="getFormControl(field.key)"
                  (click)="$event.stopPropagation()"
                  type="text"
                />
              </mat-form-field>
            }

            <!-- Number inputs -->
            @if (field.type === "number") {
              <mat-form-field
                class="filter-field"
                (click)="$event.stopPropagation()"
              >
                <mat-label>{{ field.label }}</mat-label>
                <input
                  matInput
                  [formControl]="getFormControl(field.key)"
                  (click)="$event.stopPropagation()"
                  type="number"
                />
              </mat-form-field>
            }

            <!-- Select dropdowns -->
            @if (field.type === "select" && field.key !== "city") {
              <mat-form-field
                class="filter-field"
                (click)="$event.stopPropagation()"
              >
                <mat-label>{{ field.label }}</mat-label>
                <mat-select [formControl]="getFormControl(field.key)">
                  <mat-option value="">Todos</mat-option>

                  <!-- Estado -->
                  @if (field.key === "state") {
                    @for (state of states$ | async; track state.value) {
                      <mat-option [value]="state.value">{{
                        state.label
                      }}</mat-option>
                    }
                  }
                </mat-select>
              </mat-form-field>
            }

            <!-- Caso seja city (autocomplete) -->
            @if (field.type === "select" && field.key === "city") {
              <mat-form-field
                class="filter-field"
                (click)="$event.stopPropagation()"
              >
                <mat-label>{{ field.label }}</mat-label>
                <input
                  type="text"
                  matInput
                  placeholder="Digite o município"
                  [formControl]="getFormControl(field.key)"
                  [matAutocomplete]="autoCity"
                />

                <mat-autocomplete
                  #autoCity="matAutocomplete"
                  autoActiveFirstOption
                >
                  <mat-option value="">Todos</mat-option>
                  @for (city of filteredCities$ | async; track city.value) {
                    <mat-option [value]="city.value">{{
                      city.label
                    }}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            }

            <!-- Organization autocomplete -->
            @if (field.type === "autocomplete-org") {
              <mat-form-field
                class="filter-field"
                (click)="$event.stopPropagation()"
              >
                <mat-label>{{ field.label }}</mat-label>
                <input
                  type="text"
                  matInput
                  placeholder="Digite o nome da organização"
                  [formControl]="getFormControl(field.key)"
                  [matAutocomplete]="autoOrg"
                  (click)="$event.stopPropagation()"
                />
                <mat-autocomplete
                  #autoOrg="matAutocomplete"
                  [displayWith]="displayOrganizationName"
                  autoActiveFirstOption
                >
                  <mat-option [value]="null">Todos</mat-option>
                  <mat-option [value]="{ id: -1, name: 'Geoambiente' }"
                    >Geoambiente</mat-option
                  >
                  @for (org of filteredOrganizations$ | async; track org.id) {
                    <mat-option [value]="org">{{ org.name }}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            }

            <!-- Checkbox groups -->
            @if (field.type === "checkbox-group") {
              <mat-label>{{ field.label }}</mat-label>
              @for (option of field.options; track option.value) {
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  [formControl]="getFormControl(field.key + '_' + option.value)"
                >
                  {{ option.label }}
                </mat-checkbox>
              }
            }
          </div>
        }

        <div>
          <button
            mat-button
            class="clear-btn"
            (click)="clearFilters(); $event.stopPropagation()"
          >
            Limpar
          </button>
          <button mat-button class="cancel-btn" (click)="cancel()">
            Cancelar
          </button>
          <button mat-flat-button class="apply-btn" (click)="applyFilters()">
            Aplicar
          </button>
        </div>
      </ng-template>
    </mat-menu>
  </div>
</div>
